import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import UserReducer from "./slice/user/UserSlice";
import CommonSlice from "./slice/common/CommonSlice";
import DeliveryStepsSlice from "./slice/deliverysteps/DeliveryStepsSlice";
import CustomerSlice from "./slice/admin/customer/CustomerSlice";
import AgentsSlice from "./slice/admin/agents/AgentsSlice";
import ChatSlice from "./slice/admin/chat/ChatSlice";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  blacklist: [
    "common",
    "deliverysteps",
    "admincustomer",
    "adminagents",
    "adminchat",
  ],
};
const rootReducer = combineReducers({
  auth: UserReducer,
  common: CommonSlice,
  deliverysteps: DeliveryStepsSlice,
  admincustomer: CustomerSlice,
  adminagents: AgentsSlice,
  adminchat: ChatSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
});
export const persistor = persistStore(store);
